export default __webpack_public_path__ + "static/media/same-mention.b2ff4561.webm";